module.exports = __webpack_public_path__ + "img/switch.de7aab5f.svg";